module.exports = __webpack_public_path__ + "img/logo-fas.49a975ce.png";